export default __webpack_public_path__ + "static/media/continueRegistration.f5b8dd34.avif";